import React from "react";
import { SvgProps } from "./Form";

export const TicketCreated = (props: SvgProps) => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 5.33333V13.3333C17 15.906 14.8591 18 12.2273 18H6.09091V16.6667H12.2273C14.107 16.6667 15.6364 15.1713 15.6364 13.3333V5.33333H17ZM6.77273 15.3333H4.04545C2.91773 15.3333 2 14.436 2 13.3333V4C2 2.89733 2.91773 2 4.04545 2H6.77273V2.66667C6.77273 3.402 7.38432 4 8.13636 4C8.88841 4 9.5 3.402 9.5 2.66667V2H12.2273C13.355 2 14.2727 2.89733 14.2727 4V13.3333C14.2727 14.436 13.355 15.3333 12.2273 15.3333H9.5V14.6667C9.5 13.9313 8.88841 13.3333 8.13636 13.3333C7.38432 13.3333 6.77273 13.9313 6.77273 14.6667V15.3333ZM8.13636 12C9.40455 12 10.4736 12.8507 10.7777 14H12.2273C12.603 14 12.9091 13.7013 12.9091 13.3333V4C12.9091 3.632 12.603 3.33333 12.2273 3.33333H10.7777C10.4743 4.48267 9.40523 5.33333 8.13636 5.33333C6.8675 5.33333 5.79909 4.48267 5.495 3.33333H4.04545C3.66977 3.33333 3.36364 3.632 3.36364 4V13.3333C3.36364 13.7013 3.66977 14 4.04545 14H5.495C5.79841 12.8507 6.8675 12 8.13636 12Z"
      fill="currentColor"
    />
  </svg>
);
